<button class="btn btn-light" *ngIf="clicked" (click)="clicked()">
  Import CSV
</button>
<!-- <button class="btn btn-light">Export CSV</button> -->
<div class="csv-upload-modal-container" *ngIf="showInput">
  <div *ngIf="!next" class="csv-upload-modal-content">
    <span>If your CSV file has headers please be sure the columns are named:</span>
    <br>
    <br>
    <div class="csv-field" *ngFor="let col of columnDefinitions">
      <span *ngIf="col.isRequired === true">*</span>{{col.name}}
    </div>
    <br>
    <span>and check the box below.</span>
    <span>If you do not have headers make sure all values are of these types and in the above order and leave the box
      unchecked.
    </span>
    <br>
    <br>
    <span style="font-size: .5em; color: red">* required field</span>
  </div>
  <div class="csv-submit" *ngIf="next">
    <input class="choose-file" type="file" (change)="onFileSelect($event.target.files)" placeholder="Upload file"
      accept=".csv">
    <br>
    <br>
    <span *ngIf="csvFile !== undefined">After choosing your file be sure to verify below before submitting.</span>
    <br>
    <br>
    <div class="csv-field-container" *ngFor="let field of rows">
      <span class="csv-modal-field col-4">{{field.Name}}</span>
      <span *ngIf="field.Email !== undefined" class="csv-modal-field col-6">{{field.Email}}</span>
      <span class="csv-modal-field col-1">{{field.ExternalID}}</span>
    </div>
  </div>
  <span *ngIf="!next" class="check-box"><input type="checkbox" [(ngModel)]="importHeaders" />Has headers</span>
  <button class="csv-cancel-button" (click)="closeWindow()">Cancel</button>
  <button class="csv-next-button" *ngIf="!next" (click)="nextClicked()">Next</button>
  <button disabled class="csv-next-button" *ngIf="next">Submit</button>
  <button class="csv-next-button" *ngIf="next && csvFile !== undefined" (click)="onProcess()">Submit</button>
</div>